import { useEffect, useState } from 'react';

import DropdownArrowIcon from '@/assets/all-icons/dropdown-arrow-icon';
import { useDropdownPopover } from '@/shared-components/dropdown';
import Text from '@/shared-components/text/components/Text';

export default function DropdownSort({ onChangeOption, options, defaultOption, style, getOptionLabel = null }) {
  const [open, setOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(defaultOption);
  const {
    rootRef,
    triggerRef,
    menuId,
    close,
    toggle,
    handleTriggerKeyDown,
  } = useDropdownPopover({
    open,
    onOpenChange: setOpen,
    idPrefix: 'dropdown-sort',
  });
  const resolveOptionLabel = (option) => {
    if (typeof getOptionLabel === 'function') {
      return getOptionLabel(option);
    }
    return option;
  };

  useEffect(() => {
    setSelectedOption(defaultOption);
  }, [defaultOption]);

  return (
    <>
      <div
        tabIndex={0}
        role="button"
        aria-haspopup="listbox"
        aria-expanded={open}
        aria-controls={menuId}
        style={style}
        className={`dropdown dropdown--sort dropdown-sort__container element-non-selectable${open ? " is-open" : ""}`}
        onClick={toggle}
        onKeyDown={handleTriggerKeyDown}
        ref={(node) => {
          rootRef.current = node;
          triggerRef.current = node;
        }}
      >
        <Text className="dropdown__trigger dropdown-sort__selected-option" paragraph>
          <span className="dropdown__value dropdown-sort__selected-option-label">
            {resolveOptionLabel(selectedOption)}
          </span>
          <DropdownArrowIcon className="dropdown__indicator dropdown-sort__selected-icon" />
        </Text>
        <div id={menuId} className="dropdown__menu dropdown-sort__options" role="listbox">
          {options.map((item, index) => (
            item !== selectedOption && (
              <Text
                key={index}
                className="dropdown__option dropdown-sort__option font-size-small"
                role="option"
                aria-selected={item === selectedOption}
                paragraph
                onClick={() => {
                  setSelectedOption(item);
                  if (onChangeOption) onChangeOption(item);
                  close();
                }}>
                {resolveOptionLabel(item)}
              </Text>
            )
          ))}
        </div>
      </div>
    </>
  );
}
